import { getSizesString } from '@utils/misc';

export const arrangementSizes = getSizesString(['33vw', '75vw', '50vw', '50vw', '50vw', '50vw', '50vw', '75vw']);
export const packshotSizes = getSizesString(['25vw', '50vw', '50vw', '33vw', '33vw', '33vw', '50vw', '50vw']);
export const articlesSizes = getSizesString(['50vw', '50vw', '50vw', '33vw', '25vw']);
